/* eslint-disable react/display-name */
import { ModalContext } from '@context/Modal'

export const withModal = (Component) => (props) => {
  return (
    <ModalContext.Consumer>
      {(contextProps) => <Component {...props} {...contextProps} />}
    </ModalContext.Consumer>
  )
}
